// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-section-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
  padding-bottom: 18px;
}
.dashboard-section-header__main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.dashboard-section-header__copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.dashboard-section-header__title {
  margin: 0;
  color: #101828;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
}
.dashboard-section-header__subtitle {
  margin: 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 500;
}
.dashboard-section-header__actions {
  margin-inline-start: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.dashboard-section-header--sticky {
  position: sticky;
  top: 0;
  z-index: 8;
  padding: 8px 0 18px;
}
.dashboard-section-header--no-divider {
  border-bottom: 0;
  padding-bottom: 0;
}
.dashboard-section-header__actions--filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, max-content));
  align-items: center;
  justify-content: end;
  gap: 12px;
}
.dashboard-section-header__control {
  min-width: 220px;
  max-width: 100%;
}
.dashboard-section-header__control--wide {
  min-width: 280px;
}

@media (max-width: 1024px) {
  .dashboard-section-header__main {
    align-items: stretch;
  }
  .dashboard-section-header__actions {
    margin-inline-start: 0;
    width: 100%;
    justify-content: stretch;
  }
  .dashboard-section-header__actions--filters {
    grid-template-columns: 1fr;
    justify-content: stretch;
  }
  .dashboard-section-header__control, .dashboard-section-header__control--wide {
    min-width: 100%;
  }
}
@media (max-width: 900px) {
  .dashboard-section-header__title {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/DashboardSectionHeader/DashboardSectionHeader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAAJ;AAGE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AADJ;AAIE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAHJ;AAME;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,iBAAA;AALJ;AAQE;EACE,aAAA;EACA,mEAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AANJ;AASE;EACE,gBAAA;EACA,eAAA;AAPJ;AAUE;EACE,gBAAA;AARJ;;AAYA;EAEI;IACE,oBAAA;EAVJ;EAaE;IACE,sBAAA;IACA,WAAA;IACA,wBAAA;EAXJ;EAcE;IACE,0BAAA;IACA,wBAAA;EAZJ;EAeE;IAEE,eAAA;EAdJ;AACF;AAkBA;EACE;IACE,eAAA;EAhBF;AACF","sourcesContent":[".dashboard-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n  padding-bottom: 18px;\n\n  &__main {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__copy {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  &__title {\n    margin: 0;\n    color: #101828;\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__subtitle {\n    margin: 0;\n    color: #667085;\n    font-size: 14px;\n    line-height: 1.45;\n    font-weight: 500;\n  }\n\n  &__actions {\n    margin-inline-start: auto;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n\n  &--sticky {\n    position: sticky;\n    top: 0;\n    z-index: 8;\n    padding: 8px 0 18px;\n  }\n\n  &--no-divider {\n    border-bottom: 0;\n    padding-bottom: 0;\n  }\n\n  &__actions--filters {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, max-content));\n    align-items: center;\n    justify-content: end;\n    gap: 12px;\n  }\n\n  &__control {\n    min-width: 220px;\n    max-width: 100%;\n  }\n\n  &__control--wide {\n    min-width: 280px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .dashboard-section-header {\n    &__main {\n      align-items: stretch;\n    }\n\n    &__actions {\n      margin-inline-start: 0;\n      width: 100%;\n      justify-content: stretch;\n    }\n\n    &__actions--filters {\n      grid-template-columns: 1fr;\n      justify-content: stretch;\n    }\n\n    &__control,\n    &__control--wide {\n      min-width: 100%;\n    }\n  }\n}\n\n@media (max-width: 900px) {\n  .dashboard-section-header__title {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
